import React from 'react';
import { TextField, SelectField, SelectItem } from '@kuda/ui';
import SelectCluster from '../selectCluster';
import { config } from '../config';

const FormFields = ({
  secretName,
  onSecretNameChange,
  inputError,
  secretType,
  onSecretTypeChange,
  envName,
  onEnvChange,
  projName,
  onProjChange,
  userRole,
  onClusterUserRole,
  onClusterChange,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" style={{ maxWidth: '60rem' }}>
      <TextField
        label="Secret Name"
        value={secretName}
        onChange={onSecretNameChange}
        error={!!inputError}
        helperText={inputError}
        size="sm"
      />

      <SelectField
        label="Secret Type"
        placeholder="Select secret type"
        value={secretType}
        onValueChange={onSecretTypeChange}
      >
        {config.secretTypes.map((type) => (
          <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
        ))}
      </SelectField>

      <SelectField
        label="Environment"
        placeholder="Select environment"
        value={envName}
        onValueChange={onEnvChange}
      >
        {config.environments.map((env) => (
          <SelectItem key={env.value} value={env.value}>{env.label}</SelectItem>
        ))}
      </SelectField>

      <SelectField
        label="Project/Team"
        placeholder="Select project/team"
        value={projName}
        onValueChange={onProjChange}
        disabled={userRole && userRole !== config.roles[0] && userRole !== config.roles[2]}
      >
        {config.projects.map((proj) => (
          <SelectItem key={proj.value} value={proj.value}>{proj.label}</SelectItem>
        ))}
      </SelectField>

      <div className="sm:col-span-2">
        <SelectCluster
          onClusterChange={onClusterChange}
          label="Target Clusters"
          multiSelect={true}
          userRole={onClusterUserRole}
          filterEnv={envName}
        />
      </div>
    </div>
  );
};

export default FormFields;
